import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCloudIconSecondary from './svgs/CloudIconSecondary.js';
import SvgCloudIcon from './svgs/CloudIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var cloudIcon = (props => useIcon(SvgCloudIcon, SvgCloudIconSecondary, props));

export { cloudIcon as default };
